import { Reveal } from "./Reveal";

export default function FeatureStrip({ items, testId, className = "" }) {
  const cols = items.length === 4 ? "lg:grid-cols-4" : "lg:grid-cols-3";
  return (
    <section data-testid={testId} className={`border-y border-[var(--line)] bg-white ${className}`}>
      <div className={`mx-auto max-w-[1280px] px-5 sm:px-8 lg:px-12 grid grid-cols-1 sm:grid-cols-2 ${cols}`}>
        {items.map((f, i) => (
          <Reveal key={f.title} delay={i * 0.08} className={`flex gap-5 py-8 lg:py-10 lg:px-7 first:lg:pl-0 ${i > 0 ? "lg:border-l border-[var(--line)]" : ""} ${i > 0 ? "border-t sm:border-t-0" : ""}`}>
            <f.icon className="h-10 w-10 shrink-0 text-[var(--ink)] transition-transform duration-500 hover:scale-110" strokeWidth={1.4} />
            <div>
              <h3 className="font-head font-bold uppercase text-[13px] tracking-[0.02em] leading-snug">{f.title}</h3>
              {f.text && <p className="mt-2 text-[14px] text-[var(--body)] leading-snug max-w-[220px]">{f.text}</p>}
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
